import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VehiculosService {
  private apiUrl = `${environment.apiUrl}/vehiculos`;
  private apiUpload = `${environment.apiUrl}/upload`;

  constructor(private http: HttpClient) { }

  getVehiculos(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/single`);
  }

  getVehiculosPaginados(
    page: number, 
    limit: number, 
    sortBy: string, 
    sortOrder: string, 
    search: string
  ): Observable<{ data: any[], total: number }> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString())
      .set('sortBy', sortBy)
      .set('sortOrder', sortOrder.toUpperCase())
      .set('search', search);

    return this.http.get<{ data: any[], total: number }>(this.apiUrl, { params });
  }

  getVehiculosParaExportar(
    sortBy: string, 
    sortOrder: string, 
    search: string
  ): Observable<{ data: any[], total: number }> {
    let params = new HttpParams()
      .set('sortBy', sortBy)
      .set('sortOrder', sortOrder.toUpperCase())
      .set('search', search)
      .set('export', 'true'); // Parámetro clave para obtener todos los datos

    return this.http.get<{ data: any[], total: number }>(this.apiUrl, { params });
  }

  getVehiculoById(id: number): Observable<any> {
    // Agregamos un timestamp único (?t=...) para que el navegador NO use la caché (304)
    const timestamp = new Date().getTime();
    return this.http.get(`${this.apiUrl}/${id}?t=${timestamp}`);
  }

  crearVehiculo(vehiculo: any): Observable<any> {
    return this.http.post(this.apiUrl, vehiculo);
  }

  updateVehiculo(id: number, vehiculo: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, vehiculo);
  }

  deleteVehiculo(id: number, force: boolean = false) {    
    return this.http.delete(`${this.apiUrl}/${id}?force=${force}`);
  }

  updateUserVehiculo(id: number, user_id: number): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}/user/${user_id}`, {});
  }

  removeUserVehiculo(id: number): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}/remove-user`, {});
  }

  getDocumentacionVehiculo(id: string): Observable<any> {
    // Consultar directamente los documentos desde la base de datos
    return this.http.get<any[]>(`${environment.apiUrl}/documentos`).pipe(
      map((documentos: any[]) => {
        const vehiculoId = parseInt(id);
        // Agregar protección (documentos || []) por si llega null
        const safeDocumentos = documentos || [];

        // Filtrar documentos del vehículo específico que estén activos
        const documentosVehiculo = safeDocumentos.filter(doc => 
          doc.vehiculoId === vehiculoId && 
          doc.activo === true && 
          doc.deleted === false
        );

        // Estructura base para la documentación
        let documentacion: any = {
          revision_tecnica: null,
          permiso_circulacion: null,
          seguro_obligatorio: null,
          gases: null,
          otros: []
        };

        // Mapear los documentos encontrados a la estructura esperada
        documentosVehiculo.forEach(doc => {
          if (doc.tipo === 'otros') {
            documentacion.otros.push({
              id: doc.id,
              nombre: doc.nombre,
              url: doc.path,
              fecha: doc.fecha,
              fechaVencimiento: doc.fechaVencimiento
            });
          } else if (documentacion.hasOwnProperty(doc.tipo)) {
            documentacion[doc.tipo] = {
              id: doc.id,
              nombre: doc.nombre,
              url: doc.path,
              fecha: doc.fecha,
              fechaVencimiento: doc.fechaVencimiento
            };
          }
        });

        return documentacion;
      })
    );
  }
}
